import { create } from 'lib/debug';
import assign from 'lodash/assign';
import Messenger from './messenger';
import actions from './actions';
import parentActions from './parent-actions';

const log = create('messenger');

const projectName = 'memezhibo';
const messengerName = 'parent';

let currentMessenger = null;
const targetsClose = {};

/**
 *
 * @param msg
 * {
 *     action,  对应的操作
 *     from,    来自哪个窗口
 *     callbackKey,
 *     data     参数
 * }
 */
actions.callParent = function (msg) {
  const action = parentActions[msg.action];
  const target = currentMessenger.targets[msg.from] || currentMessenger;
  const childMsg = JSON.stringify({
    action: 'callback',
    callbackKey: msg.callbackKey,
    data: action(msg),
  });
  log('[parent] send childMsg', childMsg);
  target.send(childMsg);
};
actions.closeTarget = function (data) {
  const targetName = data.targetName;
  targetsClose[targetName] && targetsClose[targetName]();
  delete targetsClose[targetName];
};

function listener(msg) {
  // try {
  const msgObj = JSON.parse(msg);

  log('[child] action:', msgObj.action, 'msgObj:', msgObj.data);

  actions[msgObj.action] && actions[msgObj.action](msgObj.data);
  // } catch (e) {
  //   throw new Error(
  //     '[messenger]-[' + messengerName + '] listener parse msg error',
  //   );
  // }
}

function init() {
  log('messenger init', currentMessenger);

  currentMessenger = new Messenger(messengerName, projectName);
  currentMessenger.listen(listener);

  initPostMessage();
}

function initPostMessage() {
  window.addEventListener(
    'message',
    (msg) => {
      try {
        if (msg && msg.data && msg.data.action) {
          actions[msg.data.action](msg.data.data);
        }
      } catch (e) {}
    },
    false,
  );
}

/**
 * 添加内嵌 iframe
 * @param target      子窗口对象
 * @param targetName  子窗口的通信名
 * @param closeTarget 用来子窗口关闭自己的
 */
function addTarget(target, targetName, closeTarget) {
  currentMessenger.addTarget(target, targetName);
  targetsClose[targetName] = closeTarget;
}

function removeTarget(targetName) {
  currentMessenger.removeTarget(targetName);
}

function send(msg) {
  currentMessenger.send(JSON.stringify(msg));
}

function refreshToken(token) {
  send({
    action: 'refreshToken',
    data: token,
  });
}

function destroy() {
  currentMessenger.clear();
  currentMessenger = null;
}

function setParentActions(updateActions) {
  assign(parentActions, updateActions);
}

function setActions(updateActions) {
  assign(actions, updateActions);
}

const messenger = {
  init,
  destroy,

  addTarget,
  removeTarget,
  send,
  refreshToken,
  setParentActions,
  parentActions,
  actions,
  setActions,
};

export default messenger;
